import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { ory } from 'src/auth/ory';
import PageLoader from 'src/UI/loader/PageLoader';
import { GenericErrorPage } from 'src/error/GenericErrorPage';
import { InvitePageRoute } from 'src/auth/invite/InvitePage';

export const InvitePageWithFlag = () => {
  const { flagEnabledCustomSettingsFlow } = useFlags();
  const [searchParams] = useSearchParams();
  const [isError, setIsError] = useState(false);
  const flowId = searchParams.get('flow');

  useEffect(() => {
    if (flagEnabledCustomSettingsFlow === false) {
      if (flowId) {
        ory
          .getSettingsFlow({ id: flowId })
          .then(({ data }) => {
            window.location.replace(data.request_url);
          })
          .catch(() => setIsError(true));
      } else {
        ory
          .createBrowserSettingsFlow()
          .then(({ data }) => {
            window.location.replace(data.request_url);
          })
          .catch(() => setIsError(true));
      }
    }
  }, [flagEnabledCustomSettingsFlow, flowId]);

  if (flagEnabledCustomSettingsFlow) {
    return <InvitePageRoute />;
  }

  return isError ? (
    <GenericErrorPage error={new Error('Failed to redirect to invite flow')} />
  ) : (
    <PageLoader />
  );
};
